/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensagensResumoDashboardAliases {
  AVATAR_0 = 'avatar-0',
  DECK_MENSAGENS = 'deck-mensagens',
  FETCH_MENSAGENS = 'fetch-mensagens',
  FIELD_TITULO = 'field-titulo',
  HPMS_MENSAGENS = 'hpms-mensagens',
  LAYOUT_0 = 'layout-0',
  LINK_MOSTRAR_TODOS = 'link-mostrar-todos',
  MAPPER_0 = 'mapper-0',
  PANEL_MENSAGENS = 'panel-mensagens',
  PANEL_MOSTRAR_TODOS = 'panel-mostrar-todos',
  TEXT_0 = 'text-0',
}
export { MensagensResumoDashboardAliases };
